<div class="classifier-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <div class="classifier-page_header-wrapper">
    <h4>
      {{ 'pages.classifier.title' | translate }}
    </h4>
    <div class="search-wrapper">
      <input
        class="search"
        class="form-control lna"
        [(ngModel)]="searchTerm"
        (ngModelChange)="getClassifiers()"
        (keyup)="handleKeyPress($event)"
        type="text"
        placeholder="{{ 'components.table.search' | translate }}" />
      <button class="clear-search" (click)="clearSearch()">
        <i class="bi bi-x-lg"></i>
      </button>
      <button class="search-btn" (click)="getClassifiers()">
        <img src="assets/images/search-icon.svg" alt="search" />
      </button>
    </div>
  </div>
  @if (isLoading) {
    <app-spinner [isLoading]="isLoading" />
  } @else {
    <div class="classifier-wrapper">
      @for (classifier of classifiers; track classifier.id) {
        <app-classifier
          [isClassifierCrudLoading]="isClassifierCrudLoading"
          [classifier]="classifier"
          [valueCount]="classifier.count || -1"
          (classifierEdit)="editClassifier($event)"
          (classifierValueAdd)="addClassifierValue($event)" />
      }
    </div>
  }
</div>
